import { Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Image } from '../../../../../models/image';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-rotation-image',
  templateUrl: './rotation-image.component.html',
  styleUrls: ['./rotation-image.component.scss'],
  animations: [
  trigger('rotate', [
    state('hidden', style({
      zIndex: 2,
      left: 0,
      width: 0,
      opacity: 0.7,
      })),
    state('left', style({
      zIndex: 5,
      left: 0,
      width: '22.5%',
      opacity: 1,
      })),
    state('center', style({
      zIndex: 10,
      left: '22%',
      width: '56%',
      opacity: 1,
      })),
    state('right', style({
      zIndex: 5,
      left: '77.5%',
      width: '22.5%',
      opacity: 1,
      })),

    state('initialization', style({
      zIndex: 0,
      left: '100%',
      width: '22.5%',
      opacity: 1,
      })),

    transition('initialization => *', [
      animate('0s')
      ]),
    transition('hidden => left', [
      animate('1.5s cubic-bezier(.3,.05,.7,.95)')
      ]),
    transition('left => center', [
      animate('1.5s cubic-bezier(.3,.05,.7,.95)')
      ]),
    transition('center => right', [
      animate('1.5s cubic-bezier(.3,.05,.7,.95)')
      ]),
    transition('right => initialization', [
      animate('1.5s cubic-bezier(.3,.05,.7,.95)')
      ])
    ])
  ]
  })

export class RotationImageComponent {
  currentState = 'initialization';
  defaultImage = false;
  image: Image;

  constructor(
    private sanitizer: DomSanitizer) {
  }

  initState(initState: string): void {
    this.currentState = initState;
  }

  initImage(initImage: Image): void {
    this.image = initImage;
  }

  /**
   * Rotate the image in its own state machine.
   * @param newImage A new image which will be shown next.
   * @param onRotationEnd Callback which is called at the end of the rotation cycle.
   */
  rotate(newImage: Image, onRotationEnd: (img: Image) => void): void {
    switch (this.currentState) {
      case 'hidden': {
        this.image = newImage;
        this.currentState = 'left';
        break;
      }
      case 'left': {
        this.currentState = 'center';
        break;
      }
      case 'center': {
        this.currentState = 'right';
        break;
      }
      case 'right': {
        this.currentState = 'initialization';
        onRotationEnd(this.image);
        break;
      }
      case 'initialization': {
        this.currentState = 'hidden';
        break;
      }
    }
  }
}
